/**
 * Cashier Config
 */

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var i18n = require('i18n');
    var utils = require('utils');
    var validation = require('util/validation.util');
    /**
     * Represents cashier config for all methods or chosen type+method
     * @param {string} [aspect] - 'method.methodType' selector for method and method type; Both parts are optional
     * @returns Object
     */
    module.exports = function(aspect) {
        var basicValidation = {
            amount: {
                required: true,
                amount: {
                    message: i18n.t('playtech.mobile.system.mobile-cashier.amount.tooltip.format')
                },
                range: {
                    message: i18n.t('playtech.mobile.system.mobile-cashier.amount.tooltip.range')
                }
            },
            accountId: {
                required: true
            },
            cvv2: {
                required: true,
                length: {
                    min: 3,
                    max: 4,
                    message: i18n.t('playtech.mobile.system.mobile-cashier.error.cvv2.length')
                },
                regexp: {
                    regexp: /^$|^\d+$/,
                    message: i18n.t('playtech.mobile.system.mobile-cashier.error.cvv2.regexp')
                }
            }
        };

        var accountIdEmailValidation = {
            required: true,
            fn: {
                fn: function($input) {
                    var value = $input.val();

                    if (value === 'add') {
                        return true;
                    }

                    this.message = i18n.t('playtech.mobile.system.tooltip.email');

                    return validation.validateField(value, { email: true });
                }
            }
        };

        var addEmailValidation = {
            fn: {
                fn: function($input, config, form) { // eslint-disable-line
                    var value = $input.val();
                    var isAddedRight = basicValidation.add.fn.fn.apply(this, arguments);
                    var isEmail = _.isEmpty(value) || validation.validateField(value, { email: true });

                    if (!isEmail) {
                        this.message = i18n.t('playtech.mobile.system.tooltip.email');
                    }
                    return isAddedRight && isEmail;
                }
            }
        };

        var result = {
            generic: {
                validationConfig: _.defaults({
                    requiredPredefinedValue: {
                        required: true
                    }
                }, basicValidation),
                withdraw: {
                    redirect: false
                }
            },
            basic: {
                validationConfig: basicValidation,
                withdraw: {
                    redirect: false
                }
            },
            PayPal: {
                redirect: true,
                validationConfig: _.defaults({
                    add: addEmailValidation,
                    accountId: accountIdEmailValidation
                }, basicValidation),
                withdraw: {
                    redirect: false
                }
            },
            Moneybookers: {
                redirect: true,
                validationConfig: _.defaults({
                    add: addEmailValidation,
                    accountId: accountIdEmailValidation
                }, basicValidation),
                withdraw: {
                    redirect: false
                }
            },
            AMEX: {
                creditCard: true
            },
            ABC: {
                creditCard: true
            },
            DINERS: {
                creditCard: true
            },
            ENTROPAY: {
                creditCard: true
            },
            LASER: {
                creditCard: true
            },
            MAESTRO: {
                creditCard: true
            },
            MC: {
                creditCard: true
            },
            SWIFF: {
                creditCard: true
            },
            VISA: {
                creditCard: true
            },
            DELTA: {
                creditCard: true
            },
            ELECTRON: {
                creditCard: true
            },
            NETeller: {
                validationConfig: _.defaults({
                    accountPwd: {
                        required: true,
                        length: {
                            min: 6,
                            max: 6,
                            message: i18n.t(
                                'playtech.mobile.system.mobile-cashier.method.NETeller.accountPwd.length.tooltip')
                        }
                    },
                    accountId: _.defaults({
                        regexp: {
                            regexp: /^$|(^[0-9]{12}$)|(^(?!^\.+)(?!.*\.+[^\w])(?=.*@.*\.)[\w\.\_\-]+@([0-9a-zA-Z\-\_]+\.){0,2}[a-zA-Z]{2,}$)/,
                            message: i18n.t(
                                'playtech.mobile.system.mobile-cashier.method.NETeller.accountId.format.tooltip')
                        }
                    }, basicValidation.accountId)
                }, basicValidation)
            },
            WebMoney: {
                redirect: true,
                validationConfig: _.defaults({
                    accountId: _.defaults({
                        regexp: {
                            regexp: /^[A-Z][0-9]{12}$/,
                            message: i18n.t(
                                'playtech.mobile.system.mobile-cashier.method.WebMoney.accountId.format.tooltip')
                        }
                    }, basicValidation.accountId)
                }, basicValidation),
                withdraw: {
                    redirect: false
                }
            },
            QIWIviaSC: {
                redirect: true,
                withdraw: {
                    redirect: false
                }
            },
            PaySafeCard: {
                redirect: true,
                withdraw: {
                    redirect: false
                }
            },
            Envoy: {
                redirect: true,
                validationConfig: _.defaults({
                    amount: _.defaults({
                        required: false
                    }, basicValidation.amount)
                }, basicValidation),
                withdraw: {
                    validationConfig: {
                        amount: {
                            required: true
                        }
                    }
                }
            },
            Ukash: {
                redirect: false,
                validationConfig: _.defaults({
                    accountId: {
                        required: true,
                        length: {
                            min: 19,
                            max: 19
                        },
                        number: {
                            priority: 50,
                            regexp: /^\d+$/,
                            message: i18n.t(
                                'playtech.mobile.system.mobile-cashier.method.Ukash.accountCode.OnlyNumber.tooltip')
                        }
                    }
                }, basicValidation)
            },
            PrePaidCard: {
                redirect: false,
                validationConfig: _.defaults({
                    accountId: {
                        required: true,
                        number: {
                            regexp: /^\d+$/,
                            message: i18n.t(
                                'playtech.mobile.system.mobile-cashier.method.Ukash.accountCode.OnlyNumber.tooltip')
                        },
                        regexp: {
                            regexp: /^\d{10}$/,
                            message: i18n.t(
                                'playtech.mobile.system.mobile-cashier.method.Ukash.accountCode.CardFieldLength.tooltip')
                        }
                    },
                    accountPwd: {
                        required: false,
                        length: {
                            min: 4,
                            max: 4
                        },
                        number: {
                            regexp: /^$|^\d+$/,
                            message: i18n.t(
                                'playtech.mobile.system.mobile-cashier.method.Ukash.accountCode.OnlyNumber.tooltip')
                        }
                    }
                }, basicValidation)

            },
            EcoCard: {
                redirect: true,
                redirectType: 'popup',
                withdraw: {
                    validationConfig: utils.deepExtend({}, basicValidation, {
                        accountId: {
                            length: {
                                min: 1,
                                max: 60
                            }
                        }
                    })
                }
            },
            IDS: {
                redirect: true,
                withdraw: {
                    validationConfig: utils.deepExtend({}, basicValidation, {
                        accountId: {
                            length: {
                                min: 1,
                                max: 30
                            },
                            regexp: {
                                regexp: /^\w+[-+ ]\w+[-+ ]\w+$/i,
                                message: i18n.t(
                                    'playtech.mobile.system.mobile-cashier.method.IDS.accountId.regexp.tooltip')
                            }
                        }
                    })
                }
            },
            DotpayBlik: {
                validationConfig: utils.deepExtend({}, basicValidation, {
                    altAccount: {
                        required: true
                    },
                    field4: {
                        required: {
                            message: i18n.t('playtech.mobile.system.mobile-cashier.blik.regulations.error')
                        }
                    }
                })
            },
            DotpayCard: {},

            BankingPayouts: {
                isGeneric: true,
                // map generic field name to IMS-hardcoded 'specificParams' name
                accountFieldsMap: {
                    'field1': 'accountHolder',
                    'field2': 'accountId',
                    'field3': 'swift',
                    'field4': 'bankCity',
                    'field5': 'bankName'
                }
            },

            BankTransferCH: {
                isGeneric: false,
                withdraw: {
                    isGeneric: true,
                }
            },

            PayPalViaSC: {},

            DotpayBankTransfer: {
                isGeneric: false,
                redirect: true,
                validationConfig: utils.deepExtend({}, basicValidation, {
                    subMethodsCodes: {
                        required: true
                    },
                    field4: {
                        required: {
                            message: i18n.t('playtech.mobile.system.mobile-cashier.DotpayBankTransfer.regulations.error')
                        }
                    },
                    field5: {
                        required: {
                            message: i18n.t(
                                'playtech.mobile.system.mobile-cashier.DotpayBankTransfer.personaldata.error')
                        }
                    }
                })
            },

            VisaCheckout: {
                creditCard: true,
                validationConfig: {
                    amount: {
                        required: true,
                        amount: {
                            message: i18n.t('playtech.mobile.system.mobile-cashier.amount.tooltip.format')
                        },
                        range: {
                            message: i18n.t('playtech.mobile.system.mobile-cashier.amount.tooltip.range')
                        }
                    },
                    accountId: {
                        required: true
                    }
                }
            }
        };

        var applyAspect = function(method, methodType) {
            if (!result[method]) {
                return;
            }

            utils.deepExtend(result[method], result[method][methodType]);
            delete result[method][methodType];
        };

        var extractAspect = function(asp) {
            var split = asp.split('.'),
                method = split[0],
                methodType = split[1];

            if (!method && !methodType) {
                return;
            }

            if (!methodType) {
                result = result[method];
                return;
            }

            if (!method) {
                _.keys(result).forEach(function(mthd) {
                    applyAspect(mthd, methodType);
                });
                return;
            }

            applyAspect(method, methodType);
            result = result[method];
        };

        if (aspect) {
            extractAspect(aspect);
        }

        return result;
    };

});
